import React from 'react';
import { Icon, Typography } from '../../index';
import './list.scss';

export const ListItem = ({
    item,
    typographyType
}) => {

    return (item &&
        <li>
            <div className="bsw-list__main">
                <div className="bsw-list__icon">
                    <Icon
                        name="chip"
                        color="$color-primary-b2"
                        size="medium"
                    />
                </div>
                <div className="bsw-list__content">
                    <Typography type={typographyType}>
                        {item}
                    </Typography>
                </div>
            </div>
        </li>
    );
};